export const ISSUE_VIEWER_KEY = 'ISSUE_VIEWER';
